export default "__VITE_ASSET__ChzOWhJi__"